module.exports = __webpack_public_path__ + "static/media/more_03.73484881.png";